import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {fromEvent, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {SnackBarDataModel} from "../../models/snack-bar-model";
import {ModalService} from "../../services/modal.service";
import {ImagePreloadService} from "../../services/image-preload.service";

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss']
})
export class SnackBarComponent implements OnInit, OnDestroy {

    public snackBarData: SnackBarDataModel;
    public snackBarBody: string = '';
    public showSnackBar: boolean;
    public defaultTimer: number = 4000;
    snackbarStyles = {};
    private $destroyed = new Subject<boolean>();
    private $removeClickEL = new Subject<boolean>();
    private imageUrls = [
        "ocsp-web-ui/dist/assets/images/icon/Web/error/negative_red.svg",
        "/erums/store/dist/assets/images/close_cross.svg",
        "ocsp-web-ui/dist/assets/images/icon/Web/close/white.svg"
    ];

    constructor(
        private snackBarService: ModalService,
        private imagePreloadService: ImagePreloadService,
        private changeRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.initSnackBarService()
    }

    public initSnackBarService = () => {
        this.snackBarService.snackBar.pipe<SnackBarDataModel>(takeUntil(this.$destroyed)).subscribe(data => {
            // to close the toast msg on clicking outside the toast msg container
            if (data.closeOnClick && data.closeOnClick === true) {
                const onClick = fromEvent(document, 'click');
                const onKeyUp = fromEvent(document, 'keyup');
                const touchend = fromEvent(document, 'touchend');
                let that = this;
                const driverID = document.getElementById("driver-tip-change-link");
                if (driverID) {
                    driverID.onblur = function () {
                        that.closeSnackBar()
                    };
                }
                touchend.pipe(map((event: any) => event), takeUntil(this.$removeClickEL)).subscribe(event => {
                    this.closeSnackBarOnEvent(event);
                });
                onClick.pipe(map((event: any) => event), takeUntil(this.$removeClickEL)).subscribe(event => {
                    this.closeSnackBarOnEvent(event);
                });
                onKeyUp.pipe(map((event: any) => event), takeUntil(this.$removeClickEL)).subscribe(event => {
                    this.closeSnackBarOnEvent(event);
                });
                const el = document.getElementById("driver-tip-change-link");
                if (el) {
                    const popupTouchend = fromEvent(el, 'touchend');
                    popupTouchend.pipe(map((event: any) => event), takeUntil(this.$removeClickEL)).subscribe(event => {
                        this.closeSnackBarOnEvent(event);
                    })
                }
            }
            this.snackBarData = data;
            this.snackBarBody = (data && data['message']) ? data['message'] : '';
            this.imagePreloadService.preloadImages(this.imageUrls)
                .then(() => {
                    this.showSnackBar = this.snackBarData.show ? true : false;
                })
                .catch(() => {
                    setTimeout(() => {
                        this.showSnackBar = this.snackBarData.show ? true : false;
                    }, 2000)
                })

            if (data.topVH) {
                this.snackbarStyles = {top: data.topVH}
            } else if (data.bottomVH) {
                this.snackbarStyles = {bottom: data.bottomVH}
            }
            if (data.leftVH) {
                this.snackbarStyles['left'] = data.leftVH
            } else if (data.rightVH) {
                this.snackbarStyles['right'] = data.rightVH
            }
            // to close the toast message on given time
            if (data.timer && data.timer > 0) {
                setTimeout(() => {
                    this.close();
                }, data.timer)
            } else {
                setTimeout(() => {
                    this.close();
                }, this.defaultTimer)
            }
        })
    }

    public close = () => {
        this.showSnackBar = false;
    }

    public closeSnackBar() {
        console.log("closeSnackBar");
        if (this.showSnackBar === true) {
            this.close();
            this.$removeClickEL.next(true);
        }
    }

    public closeSnackBarOnEvent = (event) => {
        let snackBar = document.getElementById('snackbar');
        if (snackBar && !snackBar.contains(event.target) && this.showSnackBar === true) {
            this.close();
            this.$removeClickEL.next(true);
        }
    }

    ngOnDestroy(): void {
        this.$destroyed.next(true);
        this.$destroyed.complete();
        this.$removeClickEL.next(true);
        this.$removeClickEL.complete();
    }
}
